// extracted by mini-css-extract-plugin
export default {"home":"Home_home__XVsD1","homediv":"Home_homediv__7oI1X","homeimage":"Home_homeimage__D3LYh","image":"Home_image__t0DXN","div":"Home_div__EwWW5","a":"Home_a__hJ+sy"};